import React, { useContext, useEffect, useRef, useState } from 'react';
import cls from 'classnames';
import styles from './view_navigation.module.scss';
import { SalesContext } from '../../../SalesContext';

/**
 * View navigation.
 */
export const ViewNavigation: React.FC = () => {
  const { userToken } = useContext(SalesContext);

  if (!userToken) {
    return null;
  }

  return (
    <nav className={styles.nav}>
      <ol className={styles.items}>
        <NavigationItem view="login">Logga in</NavigationItem>
        <NavigationItem view="creditcheck">Kreditupplys</NavigationItem>
        <NavigationItem view="order">Produkter</NavigationItem>
      </ol>
    </nav>
  );
}

const NavigationItem: React.FC<{ view: string; }> = ({ view, children }) => {
  const [current, setCurrent] = useState(false);
  const currentRef = useRef(current);

  function checkCurrent() {
    const element = document.getElementById(view);
    if (!view || !element) {
      return;
    }
    
    const threshold = window.innerHeight / 2;

    const { top, bottom } = document.getElementById(view).getBoundingClientRect();

    const _current = top < threshold && bottom > threshold;

    if (_current !== currentRef.current) {
      setCurrent(_current);
    }
  }

  useEffect(() => { currentRef.current = current; }, [current]);

  useEffect(() => {
    const handler = setInterval(() => checkCurrent(), 500);
    return () => clearInterval(handler);
  }, []);

  return (
    <li>
      <a
        href={`#${view}`}
        className={cls([styles.item, current ? styles.current : null])}
        onClick={e => {
          e.preventDefault();
          document.getElementById(view).scrollIntoView({ behavior: 'smooth' });
        }}>
        {children}
      </a>
    </li>
  );
}